// extracted by mini-css-extract-plugin
export var downArrow = "_fg-0";
export var infoTooltipIcon = "_fg-3";
export var label = "_fg-1";
export var optionCard = "_fg-4";
export var upArrow = "_fg-2";